import { sanitizeExternalMarketSymbol } from '#/components/markets/marketUtils';

export function parseMarketSymbol(marketSymbol = ''): {
  quoteSymbol: string;
  baseSymbol: string;
} {
  const splitSymbol = marketSymbol.split('-');
  return {
    baseSymbol: sanitizeExternalMarketSymbol(splitSymbol[0] || ''),
    quoteSymbol: sanitizeExternalMarketSymbol(splitSymbol[1] || ''),
  };
}

export function createMarketSymbol(
  baseSymbol: string,
  quoteSymbol: string
): string {
  return `${baseSymbol.toUpperCase()}-${quoteSymbol.toUpperCase()}`;
}
